/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./player-fullscreen.vue?vue&type=template&id=4492f0d3&scoped=true&"
import script from "./player-fullscreen.vue?vue&type=script&lang=ts&"
export * from "./player-fullscreen.vue?vue&type=script&lang=ts&"
import style0 from "./player-fullscreen.vue?vue&type=style&index=0&id=4492f0d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4492f0d3",
  null
  
)

export default component.exports